import styled from "@emotion/styled";
import { Card } from "@mui/material";

// The themed Card made lighter for small content on phones: the asset class
// pills and the summary's details.
export const SmallCard = styled(Card)(({ theme }) => ({
  borderWidth: 1,
  borderRadius: theme.spacing(3),
}));
